import React from "react"

class NewRoomTypeButton extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className={"btn-group"}>
        <button type="button" className={"btn btn-primary dropdown-toggle "} data-toggle="dropdown">
          {I18n.t('new_room_type')} <span className="caret"></span>
        </button>
        <ul className="dropdown-menu" role="menu">
          <li className="dropdown-item"><a className="new-tax-fee modal-iframe" data-fullscreen="true" href={this.props.table_action.new_room_path}>{I18n.t('room')}</a></li>
          <li className="dropdown-item"><a className="new-tax-fee modal-iframe" data-fullscreen="true" href={this.props.table_action.new_room_group_path}>{I18n.t('room_group')}</a></li>
          <li className="dropdown-item"><a className="new-tax-fee modal-iframe" data-fullscreen="true" href={this.props.table_action.new_daily_rental_path}>{I18n.t('daily_rental')}</a></li>


        </ul>
      </div>
    )
  }
}

export default NewRoomTypeButton
